export default "__VITE_ASSET__CxFM4qoX__"